export default __webpack_public_path__ + "static/media/banner7.e5515a2b.png";